export const Title = ({
  children,
  className,
}: {
  children: string | React.ReactNode
  className?: string
}) => (
  <h2 className={`mc-text-h2 ${className}`} style={{ fontSize: 32 }}>
    {children}
  </h2>
)
